import React from 'react';
import {Rnd} from 'react-rnd';
import IconButton from '@mui/material/IconButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-light-svg-icons';

export default class Card extends React.Component {
  render() {
    return (
      <Rnd
        style={{
          backgroundColor: this.props.color,
          borderRadius: 4,
          boxShadow:
            '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px rgba(0, 0, 0, 0.14), 0px 1px 14px rgba(0, 0, 0, 0.12)',
        }}
        size={this.props.size}
        minHeight={50}
        minWidth={60}
        position={this.props.position}
        onDragStop={(e, d) => {
          this.props.onCardDragStop({x: d.x, y: d.y});
        }}
        onResizeStop={(e, direction, ref, delta, position) => {
          this.props.onCardResizeStop(ref.offsetWidth, ref.offsetHeight, position);
        }}
        bounds={this.props.bounds}
      >
        <div className="text-right p-r-5 p-t-5">
          <IconButton onClick={this.props.onClose}>
            <FontAwesomeIcon icon={faXmark} className={this.props?.color === '#000' ? 'clr-white' : ''} />
          </IconButton>
        </div>
      </Rnd>
    );
  }
}
